import moment from 'moment';

export function defaultWorkingHours() {
    return [0, 1, 2, 3, 4, 5, 6].map((day) => {
        return {
            id: null,
            photographerId: null,
            day: day,
            isAvailable: !(day === 0 || day === 6),
            start: moment('08:00:00', 'HH:mm:ss').format(),
            end: moment('17:00:00', 'HH:mm:ss').format()
        };
    });
}
